<template>
  <dialog
    ref="helpDialog"
    class="mx-auto my-auto"
    data-cy="help-modal"
    @click.self="closeDialog"
  >
    <div class="relative">
      <button
        class="absolute -right-14 top-0 flex size-10 items-center justify-center rounded-full bg-[#545464] text-white"
        @click="closeDialog"
      >
        <span class="text-lg">&times;</span>
      </button>
      <div class="p-6">
        <h2 class="text-2xl font-semibold text-headline">
          {{ $t("SHORTCUTS.TITLE_LONG", 2) }}
        </h2>
      </div>
      <div class="shortcuts-content overflow-y-auto px-6 pb-6">
        <template v-for="group in groupedShortcuts" :key="group.context">
          <div class="flex h-14 items-center border-b border-divider">
            <span class="text-sm font-semibold text-label">
              {{ group.context }}
            </span>
          </div>
          <div
            v-for="shortcut in group.shortcuts"
            :key="shortcut.key"
            class="flex items-center justify-between border-b border-divider py-4"
          >
            <span class="w-[180px] shrink-0 text-sm text-label">
              {{ formatActionName(shortcut.action_name) }}
            </span>
            <shortcut-key-badges :shortcut />
          </div>
        </template>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { useKeyboardShortcuts } from "@/hooks/keyboardShortcuts";

import ShortcutKeyBadges from "@/components/shortcuts/ShortcutKeyBadges.vue";

const emit = defineEmits<{
  close: [];
}>();

const { groupedShortcuts, formatActionName } = useKeyboardShortcuts();

const helpDialog = ref<HTMLDialogElement>();

const closeDialog = () => {
  if (helpDialog.value?.open) {
    helpDialog.value.close();
    emit("close");
  }
};

onMounted(() => {
  helpDialog.value?.addEventListener("cancel", closeDialog);
  helpDialog.value?.showModal();
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.shortcuts-content {
  max-height: 612px;
  scrollbar-width: thin;
}

dialog {
  @apply max-h-[700px] w-[720px] overflow-visible rounded bg-white shadow-[0px_12px_32px_0px_rgba(83,90,97,0.1),0px_1px_1px_0px_rgba(83,90,97,0.05)];
  &:focus-within {
    @apply outline-none;
  }
  &::backdrop {
    backdrop-filter: blur(0.5px);
  }
}
</style>
